import {
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type ReplaceWinnersParams = Static<typeof ReplaceWinnersParamsSchema>;
export const ReplaceWinnersParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: LotteryDrawSchema.properties.id,
  },
  { additionalProperties: false, $id: 'ReplaceWinnersParamsSchema' }
);

export type ReplaceWinnersBody = Static<typeof ReplaceWinnersBodySchema>;
export const ReplaceWinnersBodySchema = Type.Object(
  {
    winners: Type.Array(
      Type.Object(
        {
          partyUid: Type.String(),
        },
        { additionalProperties: false }
      )
    ),
  },
  { additionalProperties: false, $id: 'ReplaceWinnersBodySchema' }
);

export type ReplaceWinnersResponse = Static<typeof ReplaceWinnersResponseSchema>;
export const ReplaceWinnersResponseSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'ReplaceWinnersResponseSchema' }
);
